import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=7dd5f110&"
import script from "./ShareModal.vue?vue&type=script&lang=ts&"
export * from "./ShareModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports